import Toastify from "toastify-js";

class Product {
	constructor() {
		const tabActions = {
			desktop: function(nav, toggle = true) {
				let tab_id = $(nav).attr("aria-controls");
				let $wc_tab = $('.wc-tabs li[aria-controls="' + tab_id + '"]');

				let $tab_content = $(
					'.tab-content .tab-title[aria-controls="' + tab_id + '"]'
				);

				// Scroll directly to addons
				if (tab_id == "tab-addons") {
					$("html, body").animate(
						{
							scrollTop: $("#tab-accessories").offset().top - 200
						},
						200
					);
					return;
				}

				$(".wc-tabs li").removeClass("active");
				$(".tab-content .panel").hide();
				$(".tab-content .tab-title").removeClass("open");

				if (576 <= $(window).width()) {
					$(".tab-content .tab-title").removeClass("open");
				}

				if (!$tab_content.hasClass("open")) {
					$tab_content.addClass("open");
				}

				$wc_tab.toggleClass("active");

				if (!toggle) {
					$wc_tab.addClass("active");
				}

				$("#" + tab_id).fadeIn({
					complete: function() {
						$("html, body").animate(
							{
								scrollTop: $("#" + tab_id).offset().top - 100
							},
							200
						);
					}
				});
			},
			mobile: function(nav) {
				// Change main tabs
				let tab_id = $(nav)
					.parent()
					.attr("aria-controls");
				let $wc_tab = $('.wc-tabs li[aria-controls="' + tab_id + '"]');
				let $tab_content = $(
					'.tab-content .tab-title[aria-controls="' + tab_id + '"]'
				);

				let $panel = $(".tab-content .panel#" + tab_id);

				let toggle = $tab_content.hasClass("open");

				$(".wc-tabs li").removeClass("active");
				$(".tab-content .panel").hide();
				$(".tab-content .tab-title").removeClass("open");

				if (!toggle) {
					$panel.slideDown();

					$wc_tab.toggleClass("active");
					$tab_content.toggleClass("open");
				}
			}
		};

		// Check hashbang and click tab
		if (window.location.hash) {
			const hash = window.location.hash.substring(1);

			if (hash?.split("-")?.[0] !== "tab") {
				return;
			}

			const $tabElement = $("#" + hash + "-nav");

			let tab = $tabElement.length
				? $tabElement[0]
				: $(".wc-tabs > li")[0];

			var intervalId = setInterval(function() {
				if (
					jQuery(".woocommerce-tabs .wc-tabs li").hasClass("active")
				) {
					if (576 <= $(window).width()) {
						tabActions.desktop(tab);
					} else {
						tabActions.mobile(tab);
					}

					// Exit
					clearInterval(intervalId);
				}
			}, 300);
		}

		// Add item to cart
		$(document).on(
			"click",
			".single-variation-item-actions .single_variation_add_to_cart_button",
			function(e) {
				e.preventDefault();

				const $parent = $(this).closest(
					".single-variation-item-actions"
				);

				var errorMsg = $parent
					.find('input[name="txt_error_add_to_cart"]')
					.val();
				var $form = $(this);
				var formData = {
					product_id: $parent.find('input[name="product_id"]').val(),
					variation_id: $parent
						.find('input[name="variation_id"]')
						.val(),
					quantity: $parent.find('input[name="quantity').val(),
					action: "wc_ajax_add_to_cart"
				};

				$form.css("pointer-events", "none").css("opacity", "0.7");
				$form.addClass("wc-button-loading-variation");

				let $status = $form.parent().next();

				if ($status.hasClass("adc-status")) {
					$status.remove();
				}

				// Remove existing notices
				$(
					".woocommerce-error, .woocommerce-message, .woocommerce-info"
				).remove();

				const toastDefs = {
					text: "",
					duration: 5000,
					escapeMarkup: false,
					newWindow: true,
					close: true,
					gravity: "top", // `top` or `bottom`
					position: "center", // `left`, `center` or `right`
					stopOnFocus: true, // Prevents dismissing of toast on hover
					style: {
						background: "#007b92"
					}
				};

				$.ajax({
					url: wc_add_to_cart_params.ajax_url,
					type: "POST",
					processData: true,
					data: formData,
					success: function(response) {
						if (response.fragments) {
							$(document.body).trigger("added_to_cart", [
								response.fragments,
								response.cart_hash,
								$form
							]);

							$("#site-content > .woocommerce").before(
								response.fragments.notices_html
							);

							Toastify({
								...toastDefs,
								text: response.fragments.notices_html
							}).showToast();
						}
					},
					error: function(jqXHR, textStatus, errorThrown) {
						//console.log(jqXHR);
						//console.log(textStatus);
						//console.log(errorThrown);
						Toastify({
							...toastDefs,
							text: errorMsg,
							style: {
								background: "#bd5050"
							}
						}).showToast();
					},
					complete: function(data) {
						$form.css("pointer-events", "all").css("opacity", "1");
						$form.removeClass("wc-button-loading-variation");
					}
				});

				return false;
			}
		);

		// Follow links
		$(document).on("click", "#toggle-tech-table", function(e) {
			var $btn = $(this);

			var $container = $(".model-container");
			var $table = $(".content-tab-model table.table");
			var $elems = $(".content-tab-model .attribute-extra-column");

			var expandedText = $btn.data("text-expanded");
			var expandText = $btn.data("text-expand");

			$btn.toggleClass("expanded");
			$table.toggleClass("expanded");

			if ($table.hasClass("expanded")) {
				$container.addClass("container-2xl");
			} else {
				$container.removeClass("container-2xl");
			}

			if ($btn.hasClass("expanded")) {
				$btn.html(expandedText + " -");
				$elems.removeClass("d-none");
			} else {
				$btn.html(expandText + " +");
				$elems.addClass("d-none");
			}
		});

		// Product sliders
		var $productSlider = $(".product-slider .slick-container");

		if ($productSlider.length) {
			$productSlider.each(function(e) {
				let $currentSlider = $(this);
				let $sliderNav = $currentSlider.parent().find(".slider-nav");

				$currentSlider.slick({
					prevArrow: $sliderNav.find(".prev"),
					nextArrow: $sliderNav.find(".next"),
					infinite: false,
					dots: false,
					lazyLoad: "ondemand",
					speed: 1000,
					slidesToShow: 4,
					slidesToScroll: 4,
					responsive: [
						{
							breakpoint: 1000,
							settings: {
								slidesToShow: 3,
								slidesToScroll: 3
							}
						},
						{
							breakpoint: 576,
							settings: {
								slidesToShow: 2,
								slidesToScroll: 2
							}
						}
					]
				});
			});
		}

		// DEPRECATED
		// WPML Fix: Mark first variation / or select variation by $_GET
		// $(window).on("load", function() {
		// 	var $variationSelect = $(".variations #modell");
		// 	var selected_variation = window.location.hash
		// 		.substr(1)
		// 		.split("select-variation=")[1];

		// 	if ($variationSelect.length) {
		// 		if (selected_variation) {
		// 			var selected = selected_variation.toUpperCase();

		// 			if (
		// 				$variationSelect.find(
		// 					'option[value="' + selected + '"]'
		// 				).length
		// 			) {
		// 				$variationSelect.val(selected).trigger("change");
		// 			}

		// 			return;
		// 		}

		// 		$(".variations #modell option:eq(0)")
		// 			.attr("selected", "selected")
		// 			.trigger("change");
		// 	}
		// });

		// Alter variation price
		var $priceselector = $(".product p.price");
		var originalprice = $priceselector.html();

		$(document).on("show_variation", function(event, variation) {
			$priceselector.empty();

			// Hide add-to-cart on price zero
			if (0 == variation.display_price) {
				$(".woocommerce-variation-add-to-cart").hide();
			} else {
				$(".woocommerce-variation-add-to-cart").show();
			}

			// Show price
			$priceselector.show();

			if (variation.display_price) {
				$priceselector.html(variation.price_html);
			}

			// Show related specifications
			let $table_div = $(
				'.content-tab-specifications .variation-specs[data-variation-id="' +
					variation.variation_id +
					'"]'
			);

			if ($table_div.length) {
				$(".content-tab-specifications .variation-specs").hide();
				$table_div.fadeIn();
			}
		});

		$(document).on("hide_variation", function() {
			$priceselector.html(originalprice);
		});

		// Open tab
		$(".woocommerce-tabs").on("click", ".wc-tabs li.nav-item", function(e) {
			e.stopPropagation();
			tabActions.desktop(this);
		});

		$(".woocommerce-tabs").on(
			"click",
			".tab-content .tab-title > a",
			function(e) {
				e.preventDefault();
				tabActions.mobile(this);
			}
		);

		// Product Slider
		var $productGallerySlider = $(".product-gallery .slick-container");

		$productGallerySlider.slick({
			arrows: true,
			dots: true,
			infinite: true,
			lazyLoad: "ondemand",
			speed: 1000,
			autoplay: false,
			slidesToShow: 1,
			slidesToScroll: 1
		});

		$(".product-gallery .product-gallery--bottom > div").on(
			"click",
			function() {
				$productGallerySlider.slick("slickGoTo", $(this).index());
			}
		);

		$productGallerySlider.on("afterChange", function(
			event,
			slick,
			currentSlide,
			nextSlide
		) {
			$(".product-gallery .product-gallery--bottom > div").removeClass(
				"selected"
			);
			$(".product-gallery .product-gallery--bottom > div")
				.eq(currentSlide)
				.addClass("selected");
		});
	}
}

export default Product;
